import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-involved-summary',
    templateUrl: './involved-summary.component.html',
    styleUrls: ['./involved-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class InvolvedSummaryComponent {
    @Input() involved: any; //Involved_default | any;

    public choices = [
        { choice: 'age5to12', label: '5 - 12' },
        { choice: 'age13to18', label: '13 - 18' },
        { choice: 'age19to25', label: '19 - 25' },
        { choice: 'age26to40', label: '26 - 40' },
        { choice: 'age41to60', label: '41 - 60' },
        { choice: 'age61plus', label: '61+' },
    ];

    constructor() {}
}
